import { memo } from "react";

const User = () => {
  return (
    <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.33329 9.50166V10.895C6.72991 10.6817 6.08414 10.6162 5.45023 10.7042C4.81631 10.7921 4.21276 11.0309 3.69025 11.4005C3.16773 11.77 2.74152 12.2595 2.4474 12.8279C2.15328 13.3963 1.99984 14.027 1.99996 14.667L0.666626 14.6663C0.666419 13.8523 0.852573 13.0489 1.21083 12.3179C1.56908 11.5869 2.08992 10.9476 2.73344 10.449C3.37696 9.95042 4.12608 9.60575 4.92339 9.44142C5.72071 9.2771 6.54507 9.29747 7.33329 9.50099V9.50166ZM5.99996 8.66699C3.78996 8.66699 1.99996 6.87699 1.99996 4.66699C1.99996 2.45699 3.78996 0.666992 5.99996 0.666992C8.20996 0.666992 9.99996 2.45699 9.99996 4.66699C9.99996 6.87699 8.20996 8.66699 5.99996 8.66699ZM5.99996 7.33366C7.47329 7.33366 8.66663 6.14033 8.66663 4.66699C8.66663 3.19366 7.47329 2.00033 5.99996 2.00033C4.52663 2.00033 3.33329 3.19366 3.33329 4.66699C3.33329 6.14033 4.52663 7.33366 5.99996 7.33366ZM9.99996 11.3337V9.33366H11.3333V11.3337H13.3333V12.667H11.3333V14.667H9.99996V12.667H7.99996V11.3337H9.99996Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default memo(User);
